import { Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useMatch } from 'react-router-dom';

import SearchParam from '../../components/SearchParam';
import { AutoHideTooltip } from './AutoHideTooltip';

interface SearchAttachmentContentProps {
  searchParams: URLSearchParams;
  isTableLoading: boolean;
  searchCandidateCount: number | undefined;
}

export const SearchAttachmentContent: React.FC<SearchAttachmentContentProps> = ({
  searchParams,
  isTableLoading,
  searchCandidateCount,
}) => {
  const [searchTooltip, setSearchTooltip] = useState(false);
  const [lastSearchParams, setLastSearchParams] = useState<string>('');
  const RESULTS_LIMIT_TO_SHOW_TOOLTIP = 50;
  const attachmentSearchParam = searchParams.get('attachment_search');

  const isCandidateListPage = useMatch(':tenant/opportunities/:id/analysis/');
  const isTalentPoolListPage = useMatch(':tenant/talent-pool/');
  const shouldShowTooltip = !!isCandidateListPage || !!isTalentPoolListPage;

  useEffect(() => {
    const currentSearchParams = attachmentSearchParam || '';

    if (
      !isTableLoading &&
      shouldShowTooltip &&
      searchCandidateCount &&
      searchCandidateCount > RESULTS_LIMIT_TO_SHOW_TOOLTIP &&
      !!attachmentSearchParam &&
      currentSearchParams !== lastSearchParams
    ) {
      setSearchTooltip(true);
      setLastSearchParams(currentSearchParams);
    }
  }, [
    attachmentSearchParam,
    isTableLoading,
    lastSearchParams,
    searchCandidateCount,
    shouldShowTooltip,
  ]);

  const { t } = useTranslation();

  return (
    <SearchParam name="attachment_search" onSetSearchParams={{ page: '1' }}>
      {({
        setSearchParam,
        value,
      }: {
        setSearchParam: (v: string) => void;
        value: string | string[];
      }) => (
        <AutoHideTooltip
          triggerTooltipTimer={searchTooltip}
          disableTriggerTooltipTimer={() => {
            setSearchTooltip(false);
          }}
          overlayInnerStyle={{
            textAlign: 'center',
            width: 300,
          }}
          duration={5_000}
          title={
            <>
              <Trans>Muitos resultados encontrados!</Trans>
              <br />
              <Trans>Adicione mais termos para refinar a busca.</Trans>
            </>
          }
          placement="top"
          disableHoverInteraction
        >
          <Select
            mode="tags"
            value={value ? (Array.isArray(value) ? value : value.split(',')) : []}
            onChange={(newValue) => {
              if (Array.isArray(newValue)) {
                setSearchParam(newValue.join(','));
              } else {
                setSearchParam('');
              }
            }}
            style={{ width: '100%' }}
            placeholder={t('Buscar no conteúdo dos currículos')}
            data-testid="attachment-search-input"
            maxTagCount="responsive"
          />
        </AutoHideTooltip>
      )}
    </SearchParam>
  );
};
